import ReviewDispatchSettingsModal from './ReviewDispatchSettingsModal';

export default ReviewDispatchSettingsModal;
